module.exports = __webpack_public_path__ + "img/shop1.51d4879b.jpg";